import { useEffect, useState } from "react";
import { PureTable } from "src/pages/OfferPage/TableSvgOrganizer/PureTable";
import { ProjectQuoteUserProperties } from "src/model/api/project.model";
import { GetAllManufacturerDiscountForProjectResponse } from "src/model/api/manufacturer-discount.model";
import { ManufacturerRecommendationResponse } from "src/model/api/manufacturer-recommendation";
import { Product } from "src/model/product.model";
import { CustomRowButton } from "src/pages/OfferPage/TableSvgOrganizer/CustomRowButton";
import { SectionTools } from "src/pages/OfferPage/CustomSections/CustomSection/SectionTools/SectionTools";
import { customHeaderKeyDown } from "src/pages/OfferPage/CustomSections/CustomSectionsUtils";

export const CustomSection = (
    {
        projectId,
        index,
        table,
        customSectionButtonPressed,
        setCustomSectionButtonPressed,
        detailsEnabled,
        tablesEnabled,
        currency,
        currentRowInEditing,
        setCurrentRowInEditing,
        measurementSystem,
        quoteUserProperties,
        allManufacturerDiscountForProject,
        manufacturerRecommendationForProject,
        customItemsForRecommendation
    } : {
        projectId: number;
        index?: any;
        table: any;
        customSectionButtonPressed: any;
        setCustomSectionButtonPressed: any;
        detailsEnabled: boolean;
        tablesEnabled: boolean;
        currency: string;
        currentRowInEditing: any;
        setCurrentRowInEditing: any;
        measurementSystem: string;
        quoteUserProperties: ProjectQuoteUserProperties;
        allManufacturerDiscountForProject: GetAllManufacturerDiscountForProjectResponse;
        manufacturerRecommendationForProject: ManufacturerRecommendationResponse;
        customItemsForRecommendation: Product[];
    }
) => {


    const [customRowButtonPressed, setCustomRowButtonPressed] =
        useState(null);
    const [customSection, setCustomSection] = useState(
        table && table.name ? table.name : null
    );
    const [confirmedHeader, setConfirmedHeader] = useState(null);
    const [newTable, setNewTable] = useState<any>(null);
    const [modifySection, setModifySection] = useState<boolean | null>(null);

    const tableId = table && table.id ? table.id : null;

    const handleChange = (event: any) => {
        setCustomSection(event.target.value);
    };

    useEffect(() => {
        if (customSectionButtonPressed) {
            setTimeout(function () {
                const elem = document.querySelector(".edit-header");
                if (elem) {
                    elem.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            }, 100);
        }
    }, [customSectionButtonPressed]);

    useEffect(() => {
        if (modifySection) {
            setTimeout(function () {
                const elem = document.querySelector(".edit-header");
                if (elem) {
                    elem.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            }, 100);
        }
    }, [modifySection]);

    useEffect(() => {
        if (
            table &&
            table.id &&
            currentRowInEditing &&
            ((currentRowInEditing.tableId &&
                    table.id !== currentRowInEditing.tableId) ||
                !currentRowInEditing.tableId)
        ) {
            setModifySection(false);
        }
    }, [table, currentRowInEditing]);

    return (
        <div className={`${index !== 0 ? "break-before" : ""}`}>
            <div className="room-header-container break-inside-avoid">
                <h3 className="break-after-avoid">
                    {table &&
                    table.name &&
                    modifySection &&
                    currentRowInEditing &&
                    currentRowInEditing.tableId &&
                    currentRowInEditing.tableId === table.id ? (
                        <input
                            className="section-cell edit-header"
                            type="text"
                            onKeyDown={(event) =>
                                customHeaderKeyDown(
                                    event,
                                    customSection,
                                    projectId,
                                    setCustomSectionButtonPressed,
                                    setConfirmedHeader,
                                    setNewTable,
                                    modifySection,
                                    tableId,
                                    setModifySection,
                                    setCurrentRowInEditing
                                )
                            }
                            onChange={(event) => handleChange(event)}
                            defaultValue={table.name}
                            autoFocus={true}
                        />
                    ) : table && table.name ? (
                        <span>{table.name}</span>
                    ) : (
                        <input
                            className={`section-cell ${
                                customSectionButtonPressed ? "edit-header" : ""
                            }`}
                            type="text"
                            onKeyDown={(event) =>
                                customHeaderKeyDown(
                                    event,
                                    customSection,
                                    projectId,
                                    setCustomSectionButtonPressed,
                                    setConfirmedHeader,
                                    setNewTable,
                                    modifySection,
                                    tableId,
                                    setModifySection,
                                    setCurrentRowInEditing
                                )
                            }
                            onChange={(event) => handleChange(event)}
                            autoFocus={true}
                        />
                    )}
                    <SectionTools
                        projectId={projectId}
                        table={table}
                        setCustomSectionButtonPressed={setCustomSectionButtonPressed}
                        setConfirmedHeader={setConfirmedHeader}
                        modifySection={modifySection}
                        setModifySection={setModifySection}
                        customSection={customSection}
                        confirmedHeader={confirmedHeader}
                        setNewTable={setNewTable}
                        setCurrentRowInEditing={setCurrentRowInEditing}
                    />
                </h3>
            </div>
            {table && table.name ? (
                <PureTable
                    projectId={projectId}
                    table={table}
                    detailsEnabled={detailsEnabled}
                    tablesEnabled={tablesEnabled}
                    dlStarted={false}
                    guessed={table.guessed}
                    customRowButtonPressed={customRowButtonPressed}
                    setCustomRowButtonPressed={setCustomRowButtonPressed}
                    currency={currency}
                    dispatchDownloadStates={null}
                    icons={null}
                    currentRowInEditing={currentRowInEditing}
                    setCurrentRowInEditing={setCurrentRowInEditing}
                    labourCost={null}
                    measurementSystem={measurementSystem}
                    quoteUserProperties={quoteUserProperties}
                    allManufacturerDiscountForProject={allManufacturerDiscountForProject}
                    manufacturerRecommendationForProject={manufacturerRecommendationForProject}
                    customItemsForRecommendation={customItemsForRecommendation}
                />
            ) : null}

            {tablesEnabled &&
            ((table && table.name) || (newTable && newTable.name)) ? (
                <CustomRowButton
                    table={table || newTable}
                    customRowButtonPressed={customRowButtonPressed}
                    setCustomRowButtonPressed={setCustomRowButtonPressed}
                    setCurrentRowInEditing={setCurrentRowInEditing}
                />
            ) : null}
        </div>
    );
};
